export default __webpack_public_path__ + "static/media/945.6a7bbf40.gif";